// extracted by mini-css-extract-plugin
export default {"content":"ooJEee","wired":"vJt3fI","title":"bEO0Jv"};